// extracted by mini-css-extract-plugin
export default {"card":"a4-z"};